import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { settings, briefcase, homeOutline } from 'ionicons/icons';
import { useRolePermissions, hasPermission } from '@projectK/context/RolesProvider';
const BottomNavigationBar = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const { user } = useAuthUser();
  const { rolePermissions } = useRolePermissions();
  const domain = window.location.pathname;
  useEffect(() => {
    if (domain === `/${user.roleMenuFlag[0]}/events`) {
      setValue(0);
    } else if (domain === `/${user.roleMenuFlag[0]}/product-listing`) {
      setValue(1);
    } else if (domain === `/${user.roleMenuFlag[0]}/settingsTab`) {
      setValue(2);
    } else {
      setValue(null);
    }
  }, [domain, user?.role]);
  const handleNavigation = (newValue) => {
    setValue(newValue);
    if (newValue === 0) navigate(`/${user.roleMenuFlag[0]}/events`);
    else if (newValue === 1) navigate(`/${user.roleMenuFlag[0]}/product-listing`);
    else if (newValue === 2) navigate(`/${user.roleMenuFlag[0]}/settingsTab`);
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: '15px',
          backgroundColor: '#27282a',
          zIndex: '999',
        }}
      ></div>
      <Paper
        className='mobile_view'
        sx={{
          position: 'fixed',
          bottom: 15,
          left: 0,
          right: 0,
          backgroundColor: '#27282a',
          zIndex: 1000,
          boxShadow: '0px -2px 10px rgba(0,0,0,0.3)',
        }}
        elevation={3}
      >
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => handleNavigation(newValue)}
          showLabels
          sx={{ backgroundColor: 'inherit' }}
        >
          <BottomNavigationAction
            label='Home'
            icon={<IonIcon icon={homeOutline} style={{ fontSize: '24px' }} />}
            sx={{
              color: value === 0 ? '#fff' : 'rgba(255, 255, 255, 0.7)',
            }}
          />

          {hasPermission(rolePermissions, 'Product Setup - Products Grid', 'read') && (
          <BottomNavigationAction
            label='Products'
            icon={<IonIcon icon={briefcase} style={{ fontSize: '24px' }} />}
            sx={{
              color: value === 0 ? '#fff' : 'rgba(255, 255, 255, 0.7)',
            }}
          />
          )}
          
          <BottomNavigationAction
            label='Settings'
            icon={<IonIcon icon={settings} style={{ fontSize: '24px' }} />}
            sx={{
              color: value === 0 ? '#fff' : 'rgba(255, 255, 255, 0.7)',
            }}
          />
        </BottomNavigation>
      </Paper>
    </>
  );
};
export default BottomNavigationBar;
